import {ofType} from 'redux-observable';
import {concat, EMPTY, of} from 'rxjs';
import {ajax} from 'rxjs/ajax';
import {catchError, debounceTime, filter, mapTo, mergeMap, timeout} from 'rxjs/operators';
import {AnyAction} from 'redux';
import * as LoginActions from '../actions/LoginActions';
import * as UIActions from '../actions/UIActions';
import * as SecuritySSOConstants from '../constants/SecuritySSOConstants';
import * as MC from '../constants/MotorcreditConstants';
import * as WizardMXActions from '../actions/WizardMXActions';
import {processApiError} from '../utils/ApiUtil';
import {COUNTRIES} from '../constants/AppConstants';
import {pushDataLayer} from '../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../common/constants/LabelConstants';

export const goToLoginEpic = action$ =>
    action$.pipe(
        ofType(LoginActions.LOGIN_AND_REDIRECT_ACTION.name),
        mergeMap((action) => {
            setTimeout(() =>
                window.location.href = SecuritySSOConstants.getSSOAuthorizationUrl(COUNTRIES.MX.id), 200);
            return EMPTY;
        })
    );

export const sessionExpiredEpic = (action$, state$) =>
    action$.pipe(
        ofType(LoginActions.SESSION_EXPIRED_ACTION.name),
        debounceTime(500),
        mapTo(LoginActions.LOGOUT_ACTION.action())
    );

export const logoutEpic = (action$, state$) =>
    action$.pipe(
        ofType(LoginActions.LOGOUT_ACTION.name),
        filter(action => state$.value.profile.accessToken !== '' && state$.value.profile.refreshToken !== ''),
        mergeMap((action) => {
            const state = state$.value;
            const url = SecuritySSOConstants.getSSOLogoutUrl(state$.value.countrySelector.countrySelected);
            const body = {
                client_id: SecuritySSOConstants.SSO_CLIENT_ID,
                refresh_token: state.profile.refreshToken
            };
            const headers = {
                Authorization: state.profile.accessToken,
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            };
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(LoginActions.LOGOUT_ACTION.name)),
                ajax.post(url, new URLSearchParams(body).toString(), headers).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(response =>
                        concat(
                            of(UIActions.IS_LOADED_ACTION.action(LoginActions.LOGOUT_ACTION.name)),
                            of(LoginActions.LOGOUT_SUCCESS_ACTION.action()),
                            of(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.action()),
                            of(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.action()),
                            of(WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action())
                        )
                    ),
                    catchError((error) => {
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(LoginActions.LOGOUT_ACTION.name),
                            LoginActions.LOGOUT_SUCCESS_ACTION.action(),
                            WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.action(),
                            WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.action(),
                            WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action()
                        ])(error);
                    })
                )
            );
        })
    );

export const logoutWithoutTokensEpic = (action$, state$) =>
    action$.pipe(
        ofType(LoginActions.LOGOUT_ACTION.name),
        filter(action => state$.value.profile.accessToken === '' || state$.value.profile.refreshToken === ''),
        mergeMap(action =>
            concat(
                of(LoginActions.LOGOUT_SUCCESS_ACTION.action()),
                of(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.action()),
                of(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.action()),
                of(WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action())
            )
        )
    );

export const ssoGetTokenByCodeAndRedirect = (action$, state$) =>
    action$.pipe(
        ofType(LoginActions.SSO_GET_TOKEN_BY_CODE.name),
        mergeMap((action: AnyAction) => {
            const url = SecuritySSOConstants.getSSOTokenUrl(state$.value.countrySelector.countrySelected);
            const body = {
                client_id: SecuritySSOConstants.SSO_CLIENT_ID,
                code: action.code,
                grant_type: SecuritySSOConstants.SSO_GRANT_TYPE,
                redirect_uri: SecuritySSOConstants.SSO_REDIRECT_URL,
                scope: SecuritySSOConstants.SSO_SCOPE
            };
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            };
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(LoginActions.SSO_GET_TOKEN_BY_CODE.name)),
                ajax.post(url, new URLSearchParams(body).toString(), headers).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap((response: any) => {
                        pushDataLayer(DATA_LAYER.LOGIN);
                        return concat(
                            of(UIActions.IS_LOADED_ACTION.action(LoginActions.SSO_GET_TOKEN_BY_CODE.name)),
                            of(LoginActions.SSO_GOT_TOKEN_BY_CODE.action(
                                response.response.access_token,
                                response.response.refresh_token
                            ))
                        );
                    }),
                    catchError(error =>
                        concat(
                            of(UIActions.IS_LOADED_ACTION.action(LoginActions.SSO_GET_TOKEN_BY_CODE.name)),
                            of(UIActions.ERROR_GENERAL_ACTION.action(error, null, url, body, 'POST')),
                            of(LoginActions.LOGOUT_ACTION.action())
                        )
                    )
                )
            );
        })
    );
